import React, { Component, Fragment } from "react";
import styles from "../../styles/consult-expert.module.scss";
import IconLine from "../../images/icon_line.svg";
import MainFunc from "../../models/MainFunc";
import MainData from "../../models/MainData.js";
import axios from "axios";
import moment from "moment";
import { QRCodeCanvas } from "qrcode.react";
import Modal from "react-bootstrap/Modal";
import IconModalCloseKbank from "../../images/close_modalQR.svg";
import IconModalClosePMIB from "../../images/ico_modal_close_pmib.svg";
class ConsultExpert extends Component {
  constructor(props) {
    super(props);
    this.state = {
      name: "",
      message: "",
      device: "",
      browsers: "",
      openQR: false,
      botlineLink: "",
    };
  }
  componentDidMount() {
    this.setState({
      device: this.getMobileOperatingSystem(),
      browsers: this.detectBrowsers(),
    });
  }

  getMobileOperatingSystem = () => {
    var userAgent = navigator.userAgent || navigator.vendor || window.opera;
    if (/windows phone/i.test(userAgent)) {
      return "Windows Phone";
    }

    if (/android/i.test(userAgent)) {
      return "Android";
    }

    if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
      return "iOS";
    }
    return "";
  };

  detectBrowsers = () => {
    if (
      (navigator.userAgent.indexOf("Opera") ||
        navigator.userAgent.indexOf("OPR")) != -1
    ) {
      return "Opera";
    } else if (navigator.userAgent.indexOf("Edg") != -1) {
      return "Edge";
    } else if (
      navigator.userAgent.indexOf("Chrome") != -1 ||
      navigator.userAgent.indexOf("CriOS") != -1
    ) {
      return "Chrome";
    } else if (navigator.userAgent.indexOf("Safari") != -1) {
      return "Safari";
    } else if (navigator.userAgent.indexOf("Firefox") != -1) {
      return "Firefox";
    } else if (
      navigator.userAgent.indexOf("MSIE") != -1 ||
      !!document.documentMode == true
    ) {
      //IF IE > 10
      return "IE";
    } else {
      return "unknown";
    }
  };

  getQR = () => {
    this.setState({ botlineLink: "" });
    const headers = {
      Authorization: `Bearer ${MainData.initialData.bearerAuth}`,
      "language-locale": "th",
    };
    const data = {
      productId: MainData.initialData?.productId,
      planId: MainData.userSelectedData?.selectedPlan?.planId
        ? MainData.userSelectedData?.selectedPlan?.planId
        : MainData.screenSM002.planId,
      gender: MainData.dataBroker.gender
        ? MainData.screenSM001.gender
          ? MainData.screenSM001.gender
          : MainData.dataBroker.gender
        : MainData.screenSM001.gender
        ? MainData.screenSM001.gender
        : "",
      age:
        MainData.dataBroker?.birthdateQR?.length == 10
          ? MainData.screenSM001.birthdate?.length == 10
            ? moment().format("YYYY") -
              parseInt(MainFunc.getUserBirthDate("ac")?.split("-")[0])
            : moment().format("YYYY") -
              parseInt(MainFunc.getUserBirthDateQR("ac")?.split("-")[0])
          : MainData.screenSM001.birthdate?.length == 10
          ? moment().format("YYYY") -
            parseInt(MainFunc.getUserBirthDate("ac")?.split("-")[0])
          : null,
    };
    axios
      .post(MainData.serviceURL + "/Broker/GenBotLineLink", data, { headers })
      .then(async (response) => {
        // handle success
        if (this.state.device) {
          window.location.href = response.data.botlineLink;
        } else {
          this.setState({
            openQR: true,
            botlineLink: response.data.botlineLink,
          });
        }
      })
      .catch((error) => {
        console.log(error);
        let errMsg = MainData.masterMessage.find(
          (x) => x.msgCode === "MSG1001"
        );
        this.props.errorAlert(
          true,
          !errMsg
            ? "พบปัญหาในการเชื่อมต่อไปยัง service กรุณาติดต่อผู้ดูแลระบบ"
            : errMsg.msgDescription.replace(
                "{{Service}}",
                error.response.data.data?.messageDescription
              ),
          " "
        );
        this.props.loadController(false);
      });
  };

  render() {
    return (
      <Fragment>
        <Modal
          show={this.state.openQR}
          onHide={() => this.setState({ openQR: !this.state.openQR })}
          className={`${styles.modal} modalQR`}
        >
          <img
            className={`${styles.iconCloseModal}`}
            src={IconModalCloseKbank}
            onClick={() => this.setState({ openQR: !this.state.openQR })}
          />
          <div className={styles.contentModal}>
            <div className={styles.contentModalBody}>
              <div
                className={styles.headerContact}
                dangerouslySetInnerHTML={{
                  __html: MainFunc.getLabelDtos("L0884"),
                }}
              ></div>
              <div
                className={styles.headerContact2}
                dangerouslySetInnerHTML={{
                  __html: MainFunc.getLabelDtos("L0885"),
                }}
              ></div>
              {this.state.botlineLink && (
                <div className={styles.qr}>
                  <QRCodeCanvas value={this.state.botlineLink} size={459} />
                </div>
              )}
            </div>
          </div>
        </Modal>
        <div className={styles.consultExpert}>
          <div className="container">
            <div className={styles.scHeading}>
              <div className={styles.h1}>
                {MainFunc.getLabelDtos("L0781") /*ปรึกษาผู้เชี่ยวชาญทันที*/}
              </div>
            </div>
            <div className={styles.consultCard}>
              <div className={styles.cardContainer}>
                <div className={styles.cardContent}>
                  <div>
                    <div className={styles.headding}>
                      {
                        MainFunc.getLabelDtos(
                          "L0790"
                        ) /*แชทกับผู้เชี่ยวชาญผ่าน*/
                      }{" "}
                      <br />
                      {MainFunc.getLabelDtos("L0791") /*LINE KBank Live*/}
                      <img src={IconLine} alt="" />
                    </div>
                  </div>
                  <div>
                    <a
                      id="contact_btn_linechat"
                      class={styles.btnInsure}
                      title="แชทเลย"
                      target="_blank"
                      onClick={() => {
                        MainFunc.sendDataToGTMKbank({
                          event: "track_event",
                          event_category: "chatbox",
                          event_label: "line_chat",
                          element_grouping: "button",
                          element_section: "contact",
                          element_title:
                            MainFunc.getLabelDtos("L0792") /*แชทเลย*/,
                        });
                        this.getQR();
                      }}
                    >
                      {MainFunc.getLabelDtos("L0792") /*แชทเลย*/}
                    </a>
                  </div>
                </div>
                <div className={styles.bgImage}>
                  <img src={this.props.contactImg} alt="" />
                </div>
              </div>
              <div className={styles.cardContainer}>
                <div className={styles.cardContent}>
                  <div>
                    <div className={styles.headding}>
                      {MainFunc.getLabelDtos("L0793") /*คุยกับผู้เชี่ยวชาญ*/}
                    </div>
                    <p className={styles.desc}>
                      {MainFunc.getLabelDtos("L0815") /*โทร*/}
                      {
                        MainFunc.getLabelDtos("L0783") /*02-8888888 กด 862*/
                      }{" "}
                      <br />
                      {
                        MainFunc.getLabelDtos(
                          "L0794"
                        ) /* ทุกวัน ตลอด 24 ชั่วโมง*/
                      }
                    </p>
                  </div>
                  <div>
                    <a
                      id="contact_btn_call24"
                      href={`tel:${this.props.contactWidget?.contactPhoneNumber}`}
                      className={styles.btnInsure}
                      title="Kbank Live"
                      target="_blank"
                      onClick={() => {
                        MainFunc.sendDataToGTMKbank({
                          event: "track_event",
                          event_category: "hotline",
                          event_label: "contact_hotline",
                          element_grouping: "button",
                          element_section: "contact",
                          element_title:
                            MainFunc.getLabelDtos("L0795") /*ติดต่อเลย*/,
                        });
                      }}
                    >
                      {MainFunc.getLabelDtos("L0795") /*ติดต่อเลย*/}
                    </a>
                  </div>
                </div>
                <div className={`${styles.bgImage} ${styles.custom}`}>
                  <img
                    src="https://www.kasikornbank.com/SiteCollectionDocuments/personal/insure/life/ipdopd-revamp/img/bg-consult-expert-02.png"
                    alt=""
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </Fragment>
    );
  }
}

export default ConsultExpert;
